import _ from "lodash";
import "./style.css";

const AllocationPercentageRenderer = (props: any) => {

    const getWidth = (percentage: any) => {
        if (percentage < 10) {
            return "15%";
        }
        if (percentage < 20) {
            return "20%";
        }
        if (percentage > 100) {
            return "100%";
        }
        return percentage + "%";
    }

    const getBackgroundColor = (percentage: any) => {
        return percentage <= 25 ? '#FADCD9' : percentage < 50 ? '#FFFBD5' : percentage < 75 ? '#BBDEFB' : '#D4EBD4';
    }

    if (!_.isUndefined(props?.node?.aggData?.callback_quantity)) {
        let allocationPercentage = 0;
        if (props?.node?.aggData?.callback_quantity > 0 && !_.isEmpty(props?.node?.allLeafChildren) && props?.node?.allLeafChildren[0].data.totalReturnQuantity > 0) {
            let totalCallbackQuantity = props?.node?.aggData?.callback_quantity;
            let totalReturnQuantity = props?.node?.allLeafChildren[0].data.totalReturnQuantity;
            allocationPercentage = Math.round((totalReturnQuantity / totalCallbackQuantity) * 100);
        }
        return (
            <div className="allocation-percentage text-end" style={{ width: getWidth(allocationPercentage), backgroundColor: getBackgroundColor(allocationPercentage) }}>{allocationPercentage}%</div>
        );
    }
    else {
        if (!_.isUndefined(props?.node?.data?.callback_quantity) && !_.isUndefined(props?.node?.data?.totalReturnQuantity)) {
            let totalCallbackQuantity = props?.node?.data?.callback_quantity;
            let totalReturnQuantity = props?.node?.data?.totalReturnQuantity;
            let allocationPercentage = Math.round((totalReturnQuantity / totalCallbackQuantity) * 100);
            return (
                <div className="allocation-percentage text-end" style={{ width: getWidth(allocationPercentage), backgroundColor: getBackgroundColor(allocationPercentage) }}>{allocationPercentage}%</div>
            );
        }
    }
}
export default AllocationPercentageRenderer;
